import compact from "lodash/compact";
import last from "lodash/last";
import upperFirst from "lodash/upperFirst";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useItemsEnumerate = () => {
  const { t } = useTranslation("core");

  return useCallback(
    (items: string[]): string => {
      const itemsWithoutLast = items.slice(0, -1).join(", ");
      const lastItem = last(items);

      return upperFirst(compact([itemsWithoutLast, lastItem]).join(` ${t("and")} `));
    },
    [t]
  );
};
